import { Injectable, Inject, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { IAuthApi, TokenDataGetter } from './auth.model';
import {
  TOKEN_DATA_GETTER,
  API_LOGIN_ENDPOINT,
  API_REFRESH_ENDPOINT,
  API_LOGOUT_ENDPOINT,
  REFRESH_TOKEN_KEY
} from './auth.constant';

interface DefaultResponse {
  auth: any;
  user: any;
}

@Injectable({ providedIn: 'root' })
export class ZefAuthApi implements IAuthApi {

  #http = inject(HttpClient);
  #tokenDataGetter = <unknown>inject(TOKEN_DATA_GETTER) as TokenDataGetter;
  #apiLoginEndpoint = inject(API_LOGIN_ENDPOINT);
  #apiRefreshEndpoint = inject(API_REFRESH_ENDPOINT);
  #apiLogoutEndpoint = inject(API_LOGOUT_ENDPOINT);
  #refreshTokenKey = inject(REFRESH_TOKEN_KEY);

  login$(data: any) {
    return this.#http
      .post<DefaultResponse>(
        this.#apiLoginEndpoint,
        data
      )
      .pipe(
        map((response) => ({
          tokenData: this.#tokenDataGetter(response),
          response
        }))
      );
  }

  logout$() {
    return this.#http.post<{ success: true }>(this.#apiLogoutEndpoint, {});
  }

  refresh$<D = DefaultResponse>(token: string) {
    return this.#http.post<D>(
      this.#apiRefreshEndpoint,
      { [this.#refreshTokenKey]: token }
    );
  }
}
